import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { InitiateAccountDataExportMutation } from '@/gql/graphql';

const InitiateAccountDataExport = graphql(`
  mutation InitiateAccountDataExport {
    initiateAccountDataExport {
      __typename
      ... on InitiateAccountDataExportSuccess {
        tableKeys
      }
      ... on NoExportableTablesError {
        message
      }
    }
  }
`);

const useInitiateAccountDataExport = (
  options?: UseMutationOptions<InitiateAccountDataExportMutation, unknown>
) => {
  return useMutation({
    mutationFn: () => gqlClient.request(InitiateAccountDataExport),
    ...options,
  });
};

export default useInitiateAccountDataExport;
